<div class="action-button">
  @if (type === 'participants') {
    <mat-button-toggle-group #group="matButtonToggleGroup" class="communication-action"
      [value]="selectedVal"
      [disabled]="!checkedUsers.length"
      (change)="communicationAction($event)">
      @if (eCall) {
        <mat-button-toggle value="sms" [disabled]="!checkedUsers.length" matTooltip="SMS">
          <mat-icon>textsms</mat-icon>
        </mat-button-toggle>
      }
      @if (whatsapp) {
        <mat-button-toggle value="whatsapp"  matTooltip="WhatsApp">
          <mat-icon>call</mat-icon>
        </mat-button-toggle>
      }
      <mat-button-toggle value="mail" [disabled]="!checkedUsers.length" matTooltip="{{'frontUser.withoutParents' | translate}}">
        <mat-icon>email</mat-icon>
      </mat-button-toggle>
      <mat-button-toggle value="mailWithParent" [disabled]="!checkedUsers.length" matTooltip="{{'frontUser.withParents' | translate}}">
        <mat-icon>contact_mail</mat-icon>
      </mat-button-toggle>
      <mat-button-toggle value="serial" [disabled]="!checkedUsers.length" matTooltip="{{'frontUser.Serial_Letter' | translate}}">
        <mat-icon>receipt</mat-icon>
      </mat-button-toggle>
      <mat-button-toggle value="emailList" [disabled]="!checkedUsers.length" matTooltip="{{'frontUser.emailListWithoutParents' | translate}}">
        <mat-icon>forward_to_inbox</mat-icon>
      </mat-button-toggle>
      <mat-button-toggle value="emailListWithParents" [disabled]="!checkedUsers.length" matTooltip="{{'frontUser.emailListWithParents' | translate}}">
        <mat-icon>attach_email</mat-icon>
      </mat-button-toggle>
      <mat-button-toggle value="hide" [hidden]="true">
        <mat-icon>hide</mat-icon>
      </mat-button-toggle>
    </mat-button-toggle-group>
  }
  <div class="buttons">
    @if (eventData?.subEvents && subEvents?.length) {
      <button mat-raised-button
        (click)="openSubEvents()">
        <span>{{'event.sub_events' | translate}}</span>
      </button>
    }
    @if (type === 'participants' && !blockEditCredit) {
      <button mat-raised-button
        (click)="openAddCredits()" [disabled]="!checkedUsers.length"
        class="add-product-button mat-white-bg my-12 mt-sm-0">
        <span>{{'add_credits' | translate}}</span>
      </button>
    }
    @if (type === 'participants' && skillExist) {
      <button mat-raised-button
              (click)="openAddSkills()" [disabled]="!checkedUsers.length"
              class="add-product-button mat-white-bg my-12 mt-sm-0">
        <span>{{ 'event.add_skills' | translate }}</span>
      </button>
    }
    @if (type === 'participants' && eventData?.certificateAllowed) {
      <button mat-raised-button
              (click)="openSendCertificate()" [disabled]="!checkedUsers.length"
              class="add-product-button mat-white-bg my-12 mt-sm-0">
        <span>{{ 'event.send_certificate' | translate }}</span>
      </button>
    }
    @if (type === 'participants') {
      <button (click)="openDialogAction()"><img style="height: 40px"
      src="../../../../../assets/images/development.svg"></button>
    }
  </div>
</div>
<div class="content-card mat-white-bg" style="width: 100%;">
  <div>
    @for (item of keys; track item; let i = $index) {
      <button style="width: 25%"
        [ngStyle]="{'background': selectedIndex === i ? 'gainsboro' : 'white'}"
        mat-button (click)="changeIndex(i)"
      class="participant-button" title="{{item}}">{{item}}</button>
    }
  </div>
  <mat-table [hidden]="!isEdit" class="products-table"
    #table [dataSource]="users"
    matSort
    [@animateStagger]="{value:'50'}"
    fusePerfectScrollbar>

    <ng-container matColumnDef="select">
      <mat-header-cell *matHeaderCellDef style="flex: 0 0 50px;">
        <mat-checkbox (change)="$event ? masterToggle() : null"
          [checked]="selection.hasValue() && isAllSelected"
          [indeterminate]="selection.hasValue() && !isAllSelected">
        </mat-checkbox>
      </mat-header-cell>
      <mat-cell *matCellDef="let row" style="flex: 0 0 50px;">
        <mat-checkbox (click)="$event.stopPropagation()"
          (change)="$event ? selection.toggle(row) : null; checkUser(row, $event)"
          [checked]="selection.isSelected(row)">
        </mat-checkbox>
      </mat-cell>
    </ng-container>


    <!-- Name Column -->
    <ng-container cdkColumnDef="name">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'canton.name' | translate}}</mat-header-cell>
      <mat-cell *cdkCellDef="let user">
        @if (user.frontUserId && !user.guestUserId) {
          <p class="text-truncate">{{user.frontUser.lastName}} {{user.frontUser.firstName}}</p>
        }
        @if (!user.frontUserId && user.guestUserId) {
          <p class="text-truncate">{{user.lastName}} {{user.firstName}}</p>
        }
      </mat-cell>
    </ng-container>

    <ng-container cdkColumnDef="organization">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'user.organization' | translate}}</mat-header-cell>
      <mat-cell *cdkCellDef="let user">
        @if (user.frontUserId && !user.guestUserId) {
          <p class="text-truncate">{{user.frontUser.organization.name}}</p>
        }
        @if (!user.frontUserId && user.guestUserId) {
          <p class="text-truncate">
            @if (!user.groupRegistration || !user?.nameOfOrganization) {
              {{user?.organizationName}}
            }
            @if (user?.groupRegistration && user?.nameOfOrganization) {
              {{user?.nameOfOrganization}}
            }
          </p>
        }
      </mat-cell>
    </ng-container>

    <ng-container cdkColumnDef="createdAt">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'created_at' | translate}}</mat-header-cell>
      <mat-cell *cdkCellDef="let user">
        <p class="text-truncate">{{user.createdAt | date: 'EEE, d. MMMM HH:mm'}}</p>
      </mat-cell>
    </ng-container>

    <ng-container cdkColumnDef="reward">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header class="rewards-cell">{{'reward' | translate}}</mat-header-cell>
      <mat-cell *cdkCellDef="let user" class="rewards-cell">
        @if (user.frontUserId && !user.guestUserId) {
          <p class="text-truncate">{{user.credits}}</p>
        }
      </mat-cell>
    </ng-container>

    <ng-container cdkColumnDef="targetGroup">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'user.targetGroup' | translate}}</mat-header-cell>
      <mat-cell *cdkCellDef="let user">
        @if (user.frontUserId && !user.guestUserId) {
          <p class="text-truncate">{{user.targetGroup ? user.targetGroup.ageMask : ''}}</p>
        }
      </mat-cell>
    </ng-container>

    <ng-container cdkColumnDef="isInChat">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header class="is-in-chat-cell">{{'participant.isInChat' | translate}}</mat-header-cell>
      <mat-cell *cdkCellDef="let user"  class="is-in-chat-cell">
        <div class="is-in-chat" [ngClass]="{'green': user.isInChat,
          'red': !user.isInChat}">
                @if (user.isInChat) {
                <mat-icon>done</mat-icon>
              } @else {
                <mat-icon>close</mat-icon>
              }
            </div>
        </mat-cell>
    </ng-container>

    <ng-container cdkColumnDef="addToChat">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header></mat-header-cell>
      <mat-cell *cdkCellDef="let user" >
        @if (!user.isInChat && !!user.frontUser) {
          <button mat-raised-button class="mat-accent mr-16" (click)="addToChat(user, $event)">{{'participant.addToChat' | translate}}</button>
        }
        </mat-cell>
    </ng-container>

    <ng-container cdkColumnDef="moveToParticipant">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header></mat-header-cell>
      <mat-cell *cdkCellDef="let user" >
        <img matTooltip="{{'participant.move' | translate}}" (click)="moveToParticipant($event, user)" style="width: 35px; cursor:pointer"  [src]="'assets/images/check-list.svg'">
      </mat-cell>
    </ng-container>

    <ng-container cdkColumnDef="hasCertificate">
      <mat-header-cell *cdkHeaderCellDef>{{'certificate.title' | translate}}</mat-header-cell>
      <mat-cell *cdkCellDef="let user" style="text-align: center">
        @if (!user.certificates) {
          <div class="is-in-chat red certificate">
            <mat-icon>close</mat-icon>
          </div>
        } @else {
          <a mat-icon-button
             [href]="user?.certificates?.document?.name ? getCertificateDocumentUrl(user?.certificates?.document?.name) : null"
             download target="_blank" rel="noopener noreferrer"
             [matTooltip]="'certificate.download_certificate' | translate"
             [aria-label]="'certificate.download_certificate' | translate"
             (click)="$event.stopPropagation()">
            <mat-icon style="color: green">download</mat-icon>
          </a>
        }
      </mat-cell>
    </ng-container>

    <ng-container cdkColumnDef="deleteFromParticipant">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header class="delete-cell"></mat-header-cell>
      <mat-cell *cdkCellDef="let user" class="delete-cell">
        <i matTooltip="{{'participant.delete' | translate}}" (click)="deleteFromParticipant($event, user)" class="material-icons"
          style="cursor: pointer">
          backspace
        </i>
        @if (!user.frontUserId && user.guestUserId) {
          <span
            style="margin-left: 15px; color: rgba(255,100,0,1); font-size: 18px;">G
            @if (user.groupRegistration) {
              ({{user.numberOfPeople}})
            }
          </span>
        }
      </mat-cell>
    </ng-container>


    <mat-header-row *cdkHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>

    <mat-row *cdkRowDef="let user; columns: displayedColumns;"
      (click)="openDialog(user)"
      class="product"
      [ngClass]="{'guest': !user.frontUserId && user.guestUserId}"
      matRipple>
    </mat-row>

  </mat-table>
  <mat-table [hidden]="isEdit" class="products-table"
    #table [dataSource]="users"
    matSort
    [@animateStagger]="{value:'50'}"
    fusePerfectScrollbar>

    <ng-container matColumnDef="select">
      <mat-header-cell *matHeaderCellDef  style="flex: 0 0 50px;">
        <mat-checkbox (change)="$event ? masterToggle() : null"
          [checked]="selection.hasValue() && isAllSelected"
          [indeterminate]="selection.hasValue() && !isAllSelected">
        </mat-checkbox>
      </mat-header-cell>
      <mat-cell *matCellDef="let row"  style="flex: 0 0 50px;">
        <mat-checkbox (click)="$event.stopPropagation()"
          (change)="$event ? selection.toggle(row) : null; checkUser(row, $event)"
          [checked]="selection.isSelected(row)">
        </mat-checkbox>
      </mat-cell>
    </ng-container>


    <!-- Name Column -->
    <ng-container cdkColumnDef="name">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'canton.name' | translate}}</mat-header-cell>
      <mat-cell *cdkCellDef="let user">
        @if (user.frontUserId && !user.guestUserId) {
          <span>
            @if (organizationId === user.frontUser.organizationId) {
              <p class="text-truncate">{{user.frontUser.lastName}} {{user.frontUser.firstName}}</p>
            }
            @if (organizationId !== user.frontUser.organizationId) {
              <p class="text-truncate">------ -------</p>
            }
          </span>
        }
        @if (!user.frontUserId && user.guestUserId) {
          <span>
            <!--          <p class="text-truncate">&#45;&#45;&#45;&#45;&#45;&#45; -&#45;&#45;&#45;&#45;&#45;&#45;</p>-->
            <p class="text-truncate">{{user?.lastName}} {{user?.firstName}}</p>
          </span>
        }
      </mat-cell>
    </ng-container>

    <ng-container cdkColumnDef="organization">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'user.organization' | translate}}</mat-header-cell>
      <mat-cell *cdkCellDef="let user">
        @if (user.frontUserId && !user.guestUserId) {
          <span>
            @if (organizationId === user.frontUser.organizationId) {
              <p class="text-truncate">{{user.frontUser.organization.name}}</p>
            }
            @if (organizationId !== user.frontUser.organizationId) {
              <p class="text-truncate">-------------</p>
            }
          </span>
        }
        @if (!user.frontUserId && user.guestUserId) {
          <span>
            <!--          <p class="text-truncate">&#45;&#45;&#45;&#45;&#45;&#45; -&#45;&#45;&#45;&#45;&#45;&#45;</p>-->
            <p class="text-truncate">{{user?.organizationName}}</p>
          </span>
        }
      </mat-cell>
    </ng-container>

    <ng-container cdkColumnDef="createdAt">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'created_at' | translate}}</mat-header-cell>
      <mat-cell *cdkCellDef="let user">
        <p class="text-truncate">{{user.createdAt | date: 'EEE, d. MMMM HH:mm'}}</p>
      </mat-cell>
    </ng-container>

    <ng-container cdkColumnDef="reward">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'reward' | translate}}</mat-header-cell>
      <mat-cell *cdkCellDef="let user">
        @if (user.frontUserId && !user.guestUserId) {
          <span>
            @if (organizationId === user.frontUser.organizationId) {
              <p class="text-truncate">{{user.credits}}</p>
            }
            @if (organizationId !== user.frontUser.organizationId) {
              <p class="text-truncate">----</p>
            }
          </span>
        }
        @if (!user.frontUserId && user.guestUserId) {
          <span>
            <p class="text-truncate"> </p>
          </span>
        }
      </mat-cell>
    </ng-container>

    <ng-container cdkColumnDef="targetGroup">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'user.targetGroup' | translate}}</mat-header-cell>
      <mat-cell *cdkCellDef="let user">
        @if (user.frontUserId && !user.guestUserId) {
          <p class="text-truncate">{{user.frontUser.targetGroup ? user.frontUser.targetGroup.ageMask : ''}}</p>
        }
      </mat-cell>
    </ng-container>
    <ng-container cdkColumnDef="isInChat">
          <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'participant.isInChat' | translate}}</mat-header-cell>
          <mat-cell *cdkCellDef="let user" >
            <div class="is-in-chat" [ngClass]="{'green': user.isInChat,
          'red': !user.isInChat}">
                @if (user.isInChat) {
                <mat-icon>done</mat-icon>
              } @else {
                <mat-icon>close</mat-icon>
              }
            </div>

            </mat-cell>
        </ng-container>

        <ng-container cdkColumnDef="addToChat">
          <mat-header-cell *cdkHeaderCellDef mat-sort-header></mat-header-cell>
          <mat-cell *cdkCellDef="let user" >
            @if (!user.isInChat) {
              {{'participant.addToChat' | translate}}
            }
            </mat-cell>
        </ng-container>


    <ng-container cdkColumnDef="moveToParticipant">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header></mat-header-cell>
      <mat-cell *cdkCellDef="let user"  >
        <img (click)="moveToParticipant($event, user)" style="width: 35px; cursor:pointer"  [src]="'assets/images/check-list.svg'" matTooltip="{{'participant.move' | translate}}">
      </mat-cell>
    </ng-container>

    <ng-container cdkColumnDef="hasCertificate">
      <mat-header-cell *cdkHeaderCellDef>{{'certificate.title' | translate}}</mat-header-cell>
      <mat-cell *cdkCellDef="let user">
        @if (!user.certificates) {
          <mat-icon style="color: red" (click)="showUser($event, user)">close</mat-icon>
        } @else {
          <a mat-icon-button
             [href]="user?.certificates?.document?.name ? getCertificateDocumentUrl(user?.certificates?.document?.name) : null"
             download target="_blank" rel="noopener noreferrer"
             [matTooltip]="'certificate.download_certificate' | translate"
             [aria-label]="'certificate.download_certificate' | translate"
             (click)="$event.stopPropagation()">
            <mat-icon style="color: green">download</mat-icon>
          </a>
        }
      </mat-cell>
    </ng-container>

    <ng-container cdkColumnDef="deleteFromParticipant">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header></mat-header-cell>
      <mat-cell *cdkCellDef="let user"  >
        <i (click)="deleteFromParticipant($event, user)" class="material-icons" matTooltip="{{'participant.delete' | translate}}">
          backspace
        </i>
      </mat-cell>
    </ng-container>

    <mat-header-row *cdkHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>

    <mat-row *cdkRowDef="let user; columns: displayedColumns;"
      (click)="openDialog(user)"
      class="product"
      matRipple>
    </mat-row>

  </mat-table>
  <mat-paginator #paginator
    [length]="users?.filteredData?.length"
    [pageIndex]="0"
    [pageSize]="50"
    [pageSizeOptions]="[25, 50, 100]">
  </mat-paginator>

</div>






<div [hidden]="true">
  <div id="print-section" >
    <div class="table-users" #pdfContent>
      <table>
        <img style="height: 25px" src="../../../../../assets/images/newLogo_blue.png"/>
        @if (type === 'waitingList') {
          <caption><b>{{'waiting_list_of' | translate}} `{{participants?.[keys?.[selectedIndex]]?.[0]?.event?.title}}`</b></caption>
        }
        @if (type === 'participants') {
          <caption><b>{{'list_of_participants' | translate}} `{{participants?.[keys?.[selectedIndex]]?.[0]?.event?.title}}`</b></caption>
        }
        <thead>
          <tr>
            <th scope="col">{{'canton.name' | translate}}</th>
            <!--<th scope="col">{{'user.organization' | translate}}</th>-->
            <th scope="col">{{'user.targetGroup' | translate}}</th>
            <th scope="col">{{'user.phone' | translate}}</th>
            <th scope="col">{{'user.email' | translate}}</th>
            <th scope="col">{{'contact_parent' | translate}}</th>
            <!--<th scope="col">{{'user.gender' | translate}}</th>-->
          </tr>
        </thead>
        <tbody>
          @for (participant of participants[keys[selectedIndex]]; track participant) {
            <tr>
              @if (participant.frontUserId && !participant.guestUserId) {
                <td scope="row">{{participant.frontUser.lastName}} {{participant.frontUser.firstName}}</td>
              }
              @if (!participant.frontUserId && participant.guestUserId) {
                <td scope="row">{{participant.lastName}} {{participant.firstName}}</td>
              }
              <!--<td *ngIf="participant.frontUserId && !participant.guestUserId">{{participant.frontUser.organization.name}}</td>-->
              <!--<td *ngIf="!participant.frontUserId && participant.guestUserId"></td>-->
              @if (participant.frontUserId && !participant.guestUserId) {
                <td>{{participant.frontUser.targetGroup ? participant.frontUser.targetGroup.ageMask : ''}}</td>
              }
              @if (!participant.frontUserId && participant.guestUserId) {
                <td></td>
              }
              @if (participant.frontUserId && !participant.guestUserId) {
                <td>{{participant.frontUser.phone}}</td>
              }
              @if (!participant.frontUserId && participant.guestUserId) {
                <td>{{participant.mobile}}</td>
              }
              @if (participant.frontUserId && !participant.guestUserId) {
                <td>{{participant.frontUser.email}}</td>
              }
              @if (!participant.frontUserId && participant.guestUserId) {
                <td>{{participant.email}}</td>
              }
              @if (participant.frontUserId && !participant.guestUserId) {
                <td>
                  @if (participant.mother) {
                    {{participant?.mother?.firstName}} {{participant?.mother?.lastName}},
                    {{participant?.mother?.mobile ? participant?.mother?.mobile + ', ' : participant?.mother?.phone ? participant?.mother?.phone+ ', ' : ''}}
                    {{participant?.mother?.email}}
                  }
                  @if (!participant.mother && participant.father) {
                    {{participant?.father?.firstName}} {{participant?.father?.lastName}},
                    {{participant?.father?.mobile ? participant?.father?.mobile + ', ': participant?.father?.phone ? participant?.father?.phone+ ', ' : ''}}
                    {{participant?.father?.email}}
                  }
                </td>
              }
              @if (!participant.frontUserId && participant.guestUserId) {
                <td>
                  @if (participant.parsedData) {
                    {{participant?.parsedData?.mother_name ? participant?.parsedData?.mother_name + ', ' :
                    participant?.parsedData?.father_name ?  participant?.parsedData?.father_name + ', ' : ''}}
                    {{participant?.parsedData?.mother_email ? participant?.parsedData?.mother_email + ', ' :
                    participant?.parsedData?.father_email ?  participant?.parsedData?.father_email + ', ' : ''}}
                    {{participant?.parsedData?.parents_mobile ? participant?.parsedData?.parents_mobile : ''}}
                  }
                </td>
              }
              <!--<td *ngIf="participant.frontUserId && !participant.guestUserId">{{participant.frontUser.gender}}</td>-->
              <!--<td *ngIf="!participant.frontUserId && participant.guestUserId">{{participant.gender}}</td>-->
            </tr>
          }
        </tbody>
      </table>

    </div>
  </div>




  <iframe id="iframePDF"  width="0" height="0"></iframe>
</div>
